var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRotate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ETRA",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.68 480.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.68,480.57H0V379.42H23.53v67H35.78v-57.8h22.3v57.82H71.15V378.32H94.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.68,332.49H26v40.19H0V258.31H26V298.5H94.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.68,250.47H0v-82q0-10.6,4.4-17.69A28.37,28.37,0,0,1,16,140.1a34,34,0,0,1,15.42-3.58,33.45,33.45,0,0,1,16.86,4.2A30.46,30.46,0,0,1,60,153l34.68-18.71v38.39L65.09,187v29.45H94.68Zm-53.12-34V180.41a9.19,9.19,0,0,0-2.41-6.47,8.6,8.6,0,0,0-6.67-2.61,9,9,0,0,0-4.89,1.24,8.11,8.11,0,0,0-3,3.23,9.94,9.94,0,0,0-1,4.61v36.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.68,129.09,0,83.26V45.83L94.68,0V36.47L82.16,42.11V88.49L94.68,94ZM58.63,78.17V52.43L42.63,59l-3,1.1c-1.23.46-2.63,1-4.19,1.51s-3.12,1.08-4.68,1.59-3,1-4.27,1.44v1l5.37,1.92,5.92,2.14c1.92.68,3.53,1.3,4.81,1.85Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRotate);
export default __webpack_public_path__ + "static/media/logo-rotate.312fd43a635b932f3e54b53d00bdbc06.svg";
export { ForwardRef as ReactComponent };